(function () {
  'use strict';

  var config = window.SoulyshineStandingDogMap;
  if (!config || !config.images) return;

  var silverMaterials = new Set(config.silverMaterials || []);
  var lastUrlBySection = {};
  var boundForms = new WeakSet();

  function selectedValue(picker, optionClass) {
    var wrapper = picker.querySelector('.product-form__input--option-' + optionClass);
    if (!wrapper) return '';
    var select = wrapper.querySelector('select');
    if (select) return select.value;
    var checked = wrapper.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  }

  function setImage(img, url, alt) {
    if (!img || !url) return;
    var sized = new URL(url, location.origin);
    var small = !!img.closest('[data-soulyshine-breed-thumbnail]');
    var modal = img.hasAttribute('data-soulyshine-breed-modal');
    sized.searchParams.set('width', small ? '240' : modal ? '1500' : matchMedia('(max-width: 749px)').matches ? '1000' : '1500');
    url = sized.toString();
    img.loading = modal ? 'lazy' : 'eager';
    if (img.getAttribute('src') !== url) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', url);
      img.setAttribute('data-src', url);
    }
    img.setAttribute('alt', alt);
  }

  function setHiddenProperty(form, name, value) {
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  function cartImageForPicker(picker) {
    var breed = selectedValue(picker, 'choose-breed');
    var material = selectedValue(picker, 'material');
    var breedImages = config.images[breed];
    if (!breedImages || !material) return null;

    return {
      url: silverMaterials.has(material) ? breedImages.silver : breedImages.gold,
      alt: breed + ' — ' + material
    };
  }

  function applyCurrentCartImage(form, picker) {
    var image = cartImageForPicker(picker);
    if (!image || !image.url) return null;
    setHiddenProperty(form, '_soulyshine_variant_image', image.url);
    setHiddenProperty(form, '_soulyshine_variant_image_alt', image.alt);
    return image;
  }

  function bindFormData(form, picker) {
    if (boundForms.has(form)) return;
    boundForms.add(form);

    form.addEventListener('submit', function () {
      applyCurrentCartImage(form, picker);
    }, true);
    form.addEventListener('formdata', function (event) {
      var image = cartImageForPicker(picker);
      if (!image || !image.url) return;
      event.formData.set('properties[_soulyshine_variant_image]', image.url);
      event.formData.set('properties[_soulyshine_variant_image_alt]', image.alt);
    });
  }

  function syncCartImageProperties(picker, url) {
    var sectionId = picker && picker.getAttribute('data-section');
    var productSection = sectionId && document.getElementById('MainProduct-' + sectionId);
    if (!productSection || !url) return;

    productSection.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      bindFormData(form, picker);
      applyCurrentCartImage(form, picker);
    });
  }

  function update(picker, previewOnly) {
    picker = picker || document.querySelector('[data-high-variant-picker="true"]');
    if (!picker) return;

    var breed = selectedValue(picker, 'choose-breed');
    var material = selectedValue(picker, 'material');
    var breedImages = config.images[breed];
    if (!breedImages || !material) return;

    var primaryMetal = silverMaterials.has(material) ? 'silver' : 'gold';
    var alternateMetal = primaryMetal === 'silver' ? 'gold' : 'silver';
    var url = breedImages[primaryMetal];
    var sectionId = picker.getAttribute('data-section');
    if (!sectionId || !url) return;
    var alt = breed + ' — ' + material;
    if (!previewOnly) syncCartImageProperties(picker, url);
    var previousUrl = lastUrlBySection[sectionId];

    var roots = [
      document.getElementById('MediaGallery-' + sectionId),
      document.getElementById('MediaGallery-' + sectionId + '-duplicate'),
      document.getElementById('ProductModal-' + sectionId)
    ].filter(Boolean);
    roots.forEach(function (root) {
      var list = root.querySelector('.product__media-list');
      if (list) list.style.setProperty('scroll-behavior', 'auto', 'important');
      ['primary', 'alternate'].forEach(function (slot) {
        var metal = slot === 'primary' ? primaryMetal : alternateMetal;
        var metalLabel = metal === 'silver' ? 'Silver' : 'Gold';
        var imageUrl = breedImages[metal];
        var imageAlt = slot === 'primary' ? alt : breed + ' — ' + metalLabel + ' preview';
        var slotSelector = '[data-soulyshine-breed-slot="' + slot + '"]';
        root.querySelectorAll(
          '[data-soulyshine-breed-media]' + slotSelector + ' .product__media img, ' +
          '[data-soulyshine-breed-thumbnail]' + slotSelector + ' img, ' +
          'img[data-soulyshine-breed-modal]' + slotSelector
        ).forEach(function (img) {
          img.fetchPriority = slot === 'primary' ? 'high' : 'low';
          setImage(img, imageUrl, imageAlt);
        });
        root.querySelectorAll('[data-soulyshine-breed-thumbnail]' + slotSelector).forEach(function (thumbnail) {
          var button = thumbnail.querySelector('button');
          if (button) {
            button.setAttribute('aria-label', 'View ' + breed + ' in ' + metalLabel);
            button.setAttribute('title', metalLabel + ' preview — select Material to choose your finish');
          }
          var label = thumbnail.querySelector('[data-soulyshine-breed-metal-label]');
          if (label) label.textContent = metalLabel;
        });
      });

      var breedSlide = root.querySelector('[data-soulyshine-breed-media][data-soulyshine-breed-slot="primary"]');
      if (breedSlide && previousUrl && previousUrl !== url && typeof root.setActiveMedia === 'function') {
        root.setActiveMedia(breedSlide.getAttribute('data-media-id'), false);
      }
    });

    lastUrlBySection[sectionId] = url;
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (gallery) {
      gallery.setAttribute('data-soulyshine-breed', breed);
      gallery.setAttribute('data-soulyshine-material', material);
    }
  }

  window.SoulyshineStandingDogImages = { update: update, preview: function (picker) { update(picker, true); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); }, { once: true });
  } else {
    update();
  }
})();
